//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    filter: {
      type: Object,
      default: null
    }
  },
  computed: {
    badgeLabel: function () {
      const badgeLabel = this.filter.selectedMode && this.filter.selectedMode.name ||
                        this.filter.modes && this.filter.modes.length && this.filter.modes.find(mode => mode.key === this.filter.selectedMode).name ||
                        (this.filter.contains ? 'Содержит' : null)
      return badgeLabel
    }
  }
}

